<div class="row">
  <div class="col-12">
    <div class="jitsi-meeting" allow="fullscreen">
      <h2>Loading External Content</h2>
      <iframe [src]="safeExternalUrl" frameborder="0" width="600" height="400" title="Live Class"></iframe>
      <p *ngIf="!externalUrl">Loading...</p>
    </div>
  </div>
</div>
